<template>
  <div class="generic-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title placeholder-glow mb-5">
          <span class="placeholder col-12"></span>
        </h4>
        <p class="card-text placeholder-glow">
          <span class="placeholder col-7"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-6"></span>
          <span class="placeholder col-8"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-6"></span>
          <span class="placeholder col-8"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-6"></span>
          <span class="placeholder col-4"></span>
          <span class="placeholder col-4"></span>
        </p>
      </div>
    </div>
  </div>
</template>
